/**
 * Photo-compare camera rig — Phase 3 stub.
 *
 * Phase 4 wires era toggle + photograph crossfade (Rome Reborn "Time Warp" pattern).
 * In Phase 3, NavController will mount this when state === 'photoCompare' but no
 * photo/crossfade behavior is attached.
 */
export function CompareRig() {
  return null;
}
